function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Prost\u0159edn\xED kurt");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Prost\u0159edn\xED kurt");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M160.26 35.75C165.78 35.75 170.26 40.23 170.26 45.75C170.26 62.42 170.26 102.43 170.26 119.09C170.26 124.62 165.78 129.09 160.26 129.09C151.5 129.09 135.21 129.09 126.45 129.09C120.93 129.09 116.45 124.62 116.45 119.09C116.45 102.43 116.45 62.42 116.45 45.75C116.45 40.23 120.93 35.75 126.45 35.75C135.21 35.75 151.5 35.75 160.26 35.75Z",
  id: "color"
}), React.createElement("path", {
  d: "M315.46 35.75C320.99 35.75 325.46 40.23 325.46 45.75C325.46 62.42 325.46 102.43 325.46 119.09C325.46 124.62 320.99 129.09 315.46 129.09C306.7 129.09 290.42 129.09 281.66 129.09C276.14 129.09 271.66 124.62 271.66 119.09C271.66 102.43 271.66 62.42 271.66 45.75C271.66 40.23 276.14 35.75 281.66 35.75C290.42 35.75 306.7 35.75 315.46 35.75Z",
  id: "c5SLEmGM0Z"
}), React.createElement("path", {
  d: "M247.67 35.75C253.2 35.75 257.67 40.23 257.67 45.75C257.67 62.42 257.67 102.43 257.67 119.09C257.67 124.62 253.2 129.09 247.67 129.09C238.91 129.09 222.63 129.09 213.87 129.09C208.35 129.09 203.87 124.62 203.87 119.09C203.87 102.43 203.87 62.42 203.87 45.75C203.87 40.23 208.35 35.75 213.87 35.75C222.63 35.75 238.91 35.75 247.67 35.75Z",
  id: "aanuCz6Dn"
}), React.createElement("path", {
  d: "M179.33 27.32L194.89 27.32L194.89 137.52L179.33 137.52L179.33 27.32Z",
  id: "a1K72Vxiel"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#color",
  opacity: 1,
  fill: "#000000",
  className: "color",
  fillOpacity: 0
}), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#color",
  className: "color",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 7,
  strokeOpacity: 1
}))), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c5SLEmGM0Z",
  opacity: 1,
  fill: "#ffffff",
  fillOpacity: 0
}), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#c5SLEmGM0Z",
  className: "color",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 7,
  strokeOpacity: 1
}))), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#aanuCz6Dn",
  opacity: 1,
  fill: "#000000",
  className: "color",
  fillOpacity: 1
}), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#aanuCz6Dn",
  className: "color",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 7,
  strokeOpacity: 1
}))), React.createElement("g", null, React.createElement("use", {
  xlinkHref: "#a1K72Vxiel",
  className: "color",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 1
})));

var SvgKurt2 = function SvgKurt2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "112.95376549094368 23.821258341277414 216.0085795996187 117.20019065776926",
    width: 209.01,
    height: 110.2,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKurt2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kurt_2.49a6dd5a.svg";
export { ForwardRef as ReactComponent };